import ViewPage from '@af-modules/databinding/prototypes/ViewPage';
import AppPageHead from '../modules/AppPageHead';


const ImprintPage = {
    template: 'imprint-page',

    route: '/imprint',

    isActive: false,

    scope: null,

    _isInitDone: false,

    _appPageHead: null,

    get appPageHead() {
        if (!this._appPageHead) {
            return AppPageHead.useInAutoBinding();
        }

        return this._appPageHead;
    },

    set appPageHead(value) {
        this._appPageHead = value;
    },

    constructor() {
        super.constructor();

        this._isInitDone = true;
    },

    onRouteEnter() {
        if (!this._isInitDone) {
            this.constructor();
        }

        this.isActive = true;
        this.scope.update();
    },

    onRouteLeave() {
        this.isActive = false;
        this.scope.update();
    },

    __proto__: ViewPage,
};

export default ImprintPage;



//////////////////
// WEBPACK FOOTER
// ./pages/ImprintPage.js
// module id = 60
// module chunks = 0